import { useUserProfile } from "@vega-api/extended/auth/hooks";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { buildTimeFlags } from "@vega-core/utils/buildTimeFlags";
import { isFalsy } from "@vega-core/utils/isFalsy";

import { SettingsSectionLayout } from "../../components/SettingsSectionLayout";

import { EmailAddresses } from "./EmailAddresses";
import { LPSettingsPreferences } from "./LPSettingsPreferences";

export function Notifications() {
  const { data: profile, isLoading: isUserProfileLoading } = useUserProfile();

  if (isUserProfileLoading || isFalsy(profile)) {
    return <LoadingSpinner />;
  }

  return (
    <SettingsSectionLayout bordered>
      <div className="flex flex-col gap-y-2 sm:gap-y-4">
        <EmailAddresses />
        {buildTimeFlags.reporting_settings_notifications_notification ? (
          <LPSettingsPreferences />
        ) : null}
      </div>
    </SettingsSectionLayout>
  );
}
